/* eslint-disable react/no-array-index-key */
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

// const formatCurrency = (amount: number, currency: string) => {
//   return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(
//     (amount || 0) / 100, // amount in cents
//   );
// };
const formatCurrency = (amount: number, currency?: string) => {
  const safeCurrency = currency || 'USD';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: safeCurrency,
  }).format((amount || 0) / 100); // cents to dollars
};

const InvoiceDetails = ({ data }: any) => {
  const { invoiceDetails } = data ?? {};

  // 🔹 Stripe path: invoiceDetails present
  if (invoiceDetails && invoiceDetails.lines) {
    return (
      <Paper style={{ padding: '20px', margin: '20px 0' }}>
        <Typography variant="h6" style={{ marginBottom: '20px' }}>
          Invoice Preview
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Description</TableCell>
              <TableCell align="right">Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invoiceDetails.lines.data.map((line: any, index: number) => (
              <TableRow key={index}>
                <TableCell>{line.description}</TableCell>
                <TableCell align="right">
                  {formatCurrency(line.amount, invoiceDetails.currency)}
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell>Subtotal</TableCell>
              <TableCell align="right">
                {formatCurrency(
                  invoiceDetails.subtotal,
                  invoiceDetails.currency,
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Total</TableCell>
              <TableCell align="right">
                {formatCurrency(invoiceDetails.total, invoiceDetails.currency)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    );
  }

  // 🔹 PayPal path: no invoiceDetails, just normalized data
  const amount = data?.prices?.totalPrice ?? data?.amount ?? 0;
  const currency = data?.currency ?? 'USD';
  const productName = data?.productName ?? 'PayPal Subscription';

  return (
    <Paper style={{ padding: '20px', margin: '20px 0' }}>
      <Typography variant="h6" style={{ marginBottom: '20px' }}>
        Subscription Summary
      </Typography>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>Plan</TableCell>
            <TableCell align="right">{productName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Total</TableCell>
            <TableCell align="right">
              {formatCurrency(amount, currency)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
};

export default InvoiceDetails;
